<template>
  <div data-testid="studio-page-intro" class="tw-mb-10 tw-gap-10 tw-pt-2">
    <h2 class="tw-mb-2 tw-text-xl tw-font-medium tw-leading-tight tw-tracking-tight tw-text-black dark:tw-text-white">
      {{ title }}
    </h2>
    <div class="tw-max-w-xl tw-pt-2 tw-text-sm tw-text-black dark:tw-text-white lg:tw-pt-0">
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'StudioPageIntro',
  props: {
    title: {
      type: String,
      required: true
    }
  }
});
</script>
